
<template>
  <div :class="[payload.weigth, payload.alignment]">
    <p class="h2">{{payload.text}}</p>
  </div>
</template>
<script>
export default {
  props: {
    payload: {
      default: () => {}
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";
.cell {
  @include breakpoint(medium down) {
    text-align: left !important;
  }
  p {
    font-weight: $global-weight-normal;
  }
  &.bold {
    /deep/ p {
      font-weight: $global-weight-bold;
    }
  }
}
</style>